import { handleVersionMismatch } from 'actions/versionSync';
import { CHANGE_OUTFIT_FAILURE, CHANGE_OUTFIT_REQUESTED, CHANGE_OUTFIT_SUCCESS, } from 'actiontypes/myself';
import { clearCache as clearCardCache } from 'actions/cards';
import { clearCache as clearStoryletCache } from 'actions/storylet';
import { fetchPlans } from 'actions/plans';
import { VersionMismatch } from 'services/BaseService';
import MyselfService from 'services/MyselfService';

import fetchMyself from './fetchMyself';
import { IMyselfService } from 'types/myself';

const changeOutfitRequested = () => ({ type: CHANGE_OUTFIT_REQUESTED });

const changeOutfitSuccess = (data: { name: string, qualityId: number }) => ({
  type: CHANGE_OUTFIT_SUCCESS,
  payload: data,
});

const changeOutfitFailure = (error: any) => ({
  type: CHANGE_OUTFIT_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * CHANGE OUTFIT
 -----------------------------------------------------------------------------*/
export default changeOutfit(new MyselfService());

export function changeOutfit(service: IMyselfService) {
  return (outfitId: number) => async (dispatch: Function) => {
    dispatch(changeOutfitRequested());

    // Because our storylet/card eligibility may have changed, we need to
    // clear the storylet/card cache and fetch the next time we hit the
    // tab. We *don't* directly fetch, because this could lead to sending a
    // character directly to a Menace state because of transient modified Menaces
    dispatch(clearCardCache());
    dispatch(clearStoryletCache());

    try {
      const { data } = await service.changeOutfit(outfitId);
      // We've changed outfits
      dispatch(changeOutfitSuccess(data));

      // Because our effective highway qualities may have changed, we need to
      // update the plans and myself tab
      dispatch(fetchMyself());
      dispatch(fetchPlans());
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      dispatch(changeOutfitFailure(error));
      throw error;
    }
  };
}